import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { getChangeSectionLayoutPopoverState } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { layoutSectionHoverPositionsFrozen, layoutSectionHoverPositionsThawed
// @ts-expect-error Untyped module
} from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
// @ts-expect-error Untyped module
import { closeChangeSectionLayoutPopover } from 'ContentEditorUI/redux/actions/inpageActions';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PopoverContent = () => {
  return /*#__PURE__*/_jsxs(View, {
    padding: "400",
    inlineSize: "340px",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      marginBlockEnd: "400",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "changeSectionLayoutPopover.title"
      })
    }), /*#__PURE__*/_jsx(ScrollContainer, {
      maxHeight: "550px",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "200"
      })
    })]
  });
};
const ChangeSectionLayoutPopover = ({
  children,
  sectionName
}) => {
  const changeSectionLayoutPopoverState = useSelector(getChangeSectionLayoutPopoverState);
  const isPopoverOpen = changeSectionLayoutPopoverState.isOpen && changeSectionLayoutPopoverState.id === sectionName;
  const dispatch = useDispatch();
  const handleClose = useCallback(() => {
    dispatch(closeChangeSectionLayoutPopover());
  }, [dispatch]);
  useEffect(() => {
    // Since the popover is attached to the hover overlay toolbar, we
    // need to freeze the hover positions so that the toolbar doesn't get
    // unmounted
    if (isPopoverOpen) {
      dispatch(layoutSectionHoverPositionsFrozen());
    } else {
      dispatch(layoutSectionHoverPositionsThawed());
    }
  }, [dispatch, isPopoverOpen]);
  const handlePopoverOpenChange = useCallback(evt => {
    if (!evt.target.value) {
      handleClose();
    }
  }, [handleClose]);
  return /*#__PURE__*/_jsx(Popover, {
    margin: "400",
    arrowSize: "none",
    placement: "bottom",
    "data-test-id": "change-section-layout-popover",
    open: isPopoverOpen,
    onOpenChange: handlePopoverOpenChange,
    closeOnOutsideClick: true,
    Content: PopoverContent,
    children: children
  });
};
export default ChangeSectionLayoutPopover;